import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import Typography from 'Components/UI/Typography';
import PhotoUploader from 'Views/Onboarding/Components/PhotoUploader';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import RemoveButton from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/RemoveButton';
import { FDBox, FDStack } from '@facet-wealth/design';

const styles = (theme) => ({
  root: {},
  text: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  field: {
    marginBottom: theme.spacing(2),
  },
  title: {
    fontSize: '32px',
    textAlign: 'center',
  },
});

function FamilyMemberDetailLayout({
  classes,
}) {
  useScrollTopOnMount();
  const {
    resource,
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();

  return (
    <FDBox>
      <PhotoUploader
        resource={resource}
      />
      <FDStack direction={'column'} spacing={5}>
        <Typography
          className={classes.title}
          variant={'h1'}
          color={'primary'}
          weight={'medium'}
        >
          {resource.attr('title')}
        </Typography>
        <FDBox>
          <div className={classes.fields}>
            {resource.meta().template().list().filter((field) => {
              return field.attr('hidden') !== true;
            })
              .map((field) => {
                return (
                  <MetaField
                    key={field.id()}
                    attr={field.attr('name')}
                    onChange={(v) => {
                      if (field.attr('name') === 'relation') {
                        resource.meta().field('emailAddress').attr('hidden', !(v === 'spouse' || v === 'significantOther'));
                      }
                    }}
                  />
                );
              })}
          </div>

          <RemoveButton
            resource={resource}
            dialogProps={{
              message: 'Removing this family member will delete their information. This cannot be undone.',
              title: 'Remove Family Member?',
            }}
            test="remove-family-member-button"
          />
        </FDBox>
      </FDStack>
      <SurveyStepFooter
        onSubmit={onSubmitMetaForm}
        NextButtonProps={{
          test: 'survey-family-member-detail-submit-button',
        }}
      />
    </FDBox>
  );
}

FamilyMemberDetailLayout.propTypes = {
  classes: PropTypes.object.isRequired,
};

FamilyMemberDetailLayout.defaultProps = {};

export default withStyles(styles)(FamilyMemberDetailLayout);
